import { AppServices } from '@singularsystems/neo-core';
import { AppService, AppTypes } from 'st-app/Services/AppService';
import { IParticipantModuleConfigApiClient } from './ApiClients/ParticipantModuleConfigApiClient';
import { IBeneficiariesApiClient } from './ApiClients/BeneficiariesApiClient';
import ParticipantConfigService from './Services/ParticipantConfigService';

const CommonParticipantsTypes = {
    ApiClients: {
        ParticipantModuleConfigApiClient: new AppServices.ServiceIdentifier<IParticipantModuleConfigApiClient>("Participants.ApiClients.ParticipantModuleConfigApiClient"),
        BeneficiariesApiClient: new AppServices.ServiceIdentifier<IBeneficiariesApiClient>("Participants.ApiClients.BeneficiariesApiClient"),
    },
    Services: {
        ParticipantConfigService: new AppServices.ServiceIdentifier<ParticipantConfigService>("Participants.Services.ParticipantConfigService"),
    }
}

const Types = {
    ...AppTypes,
    Participants: CommonParticipantsTypes
}

export { AppService, Types, CommonParticipantsTypes }